export let TicketType = /*#__PURE__*/function (TicketType) {
  TicketType["IssueType"] = "issue";
  TicketType["RequestType"] = "request";
  return TicketType;
}({});

// Confusingly, this can represent either an IssueType or RequestType